import { render, staticRenderFns } from "./RegularVideoCard.vue?vue&type=template&id=fd5211b8&scoped=true"
import script from "./RegularVideoCard.vue?vue&type=script&lang=js"
export * from "./RegularVideoCard.vue?vue&type=script&lang=js"
import style0 from "./RegularVideoCard.vue?vue&type=style&index=0&id=fd5211b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5211b8",
  null
  
)

export default component.exports